// export const apiBaseUrl = "http://localhost:8083/api";
export const apiBaseUrl = "/api";
